<!-- 策略添加行为 -->
<template>
  <div class="container">
    <!-- 行为类型选择 -->
    <a-modal :title="$t('message.pushStrategy.createBehavior')"  :visible="actionCreateVisible" width="700px"
      :maskClosable="false" @cancel="actionCreateVisibleCancel" destroyOnClose>
      <template slot="footer">

        <a-button :size="$globalSize" type="primary" :disabled="disabledSubmitBtn" :loading="loading_sms"
          @click="saveActionHandle(actionTypeObj.actionType == 1 ? 'sms' : 'email')" v-if="actionTypeObj.actionType">
          {{ $t("message.pushStrategy.saveAndAddAction") }}
        </a-button>
      </template>
      <a-spin :spinning="formLoading" >
        <a-form-model ref="ationTypeRef" :rules="ationTypeRules" :model="actionTypeObj" :label-col="labelCol"
          :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('message.pushStrategy.behaviorSelection')" prop="actionType">
            <a-select :size="$globalSize" @change="changeActionType" v-model="actionTypeObj.actionType"
              :options="actionTypeList" />
          </a-form-model-item>
          
        </a-form-model>
        <a-form-model v-if="actionTypeObj.actionType == 1 && actionCreateVisible" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('message.pushStrategy.pushTemplateSelection')">
            <a-radio-group :size="$globalSize" v-model="appModel">
              <a-radio value="1" disabled>{{ $t('message.pushStrategy.smartCopywriting') }}</a-radio>
              <a-radio value="2">{{ $t('message.pushStrategy.customizedCopy') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>


          <template v-if="appModel == '2'">
            <a-form-model-item :label="$t('message.pushStrategy.pushMessage')">
              <a-select :size="$globalSize" key="bb" label-in-value show-search option-filter-prop="children"
                :filter-option="txtFilterOption" @change="tabChangeXun"
                :placeholder="$t('message.pushStrategy.chooseText')" v-model="textValue">
                <a-select-option v-for="item in push_txts" :key="item.id" :value="item.id" :label="item.content_name"
                  :title="item.content_detail">
                  {{ item.content_name }} ({{ item.id }})
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </template>

          <a-form-model-item :label="$t('message.pushStrategy.reminderTime')">
            <div class="flex justify-space-between align-item-center grid-gap-16">
              <a-select style="flex:1" :size="$globalSize" v-model="strategyActionObj.push_time"
                :placeholder="$t('message.pushStrategy.pleaseSelectTime')" @change="handleTimeZoneChange"
                :options="reminderTimeOpt">

              </a-select>
              <div style="padding-right: 16px;">{{ strategyActionObj.time_zone }}</div>
            </div>
          </a-form-model-item>
          <a-row v-if="showTimeZoneWarning">
            <a-col :span="labelCol.span"></a-col>
            <a-col :span="wrapperCol.span">
              <a-tag color="red" style="height: 40px;width:100%;line-height: 40px;">{{
      $t('message.strategyManagement.timeZoneWarning') }}</a-tag>
            </a-col>
          </a-row>
        </a-form-model>
        <a-form-model v-if="actionTypeObj.actionType == 2&&actionCreateVisible" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item :label="$t('message.pushStrategy.pushTemplateSelection')">
            <a-radio-group :size="$globalSize" v-model="appModel">
              <a-radio value="1" disabled>{{ $t("message.pushStrategy.smartCopywriting") }}</a-radio>
              <a-radio value="2">{{ $t("message.pushStrategy.customizedCopy") }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <template v-if="appModel == '2'">
            <a-form-model-item :label="$t('message.pushStrategy.pushMessage')">
              <a-select :size="$globalSize" key="bb" label-in-value show-search option-filter-prop="children"
                :filter-option="txtFilterOption" @change="tabChangeXun"
                :placeholder="$t('message.pushStrategy.chooseText')" v-model="textValue">
                <a-select-option v-for="item in push_txts" :key="item.id" :value="item.id" :label="item.content_name"
                  :title="item.content_detail">
                  {{ item.content_name }} ({{ item.id }})
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </template>

          <a-form-model-item :label="$t('message.pushStrategy.reminderTime')" prop="push_time">
            <div class="flex justify-space-between align-item-center grid-gap-16">
              <a-select style="flex:1" :size="$globalSize" v-model="strategyActionObj.push_time"
              
                :placeholder="$t('message.pushStrategy.pleaseSelectTime')" @change="handleTimeZoneChange"
                :options="reminderTimeOpt">
              </a-select>
              <div style="padding-right: 16px;">{{ strategyActionObj.time_zone }}</div>
            </div>
          </a-form-model-item>
          <a-row v-if="showTimeZoneWarning">
            <a-col :span="labelCol.span"></a-col>
            <a-col :span="wrapperCol.span">
              <a-tag color="red" style="height: 40px;width:100%;line-height: 40px;">{{
      $t('message.strategyManagement.timeZoneWarning') }}</a-tag>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>

  </div>
</template>
<script>
import utils from "@/utils";
import moment from "moment";
import SmartCoupon from "./SmartCoupon.vue";
import launchStrategyService from "@/interface/pages/Strategy/launchStrategyService";
import contentListService from "@/interface/pages/TxtManagement/contentListService";
import { contentChannel } from '../../../../utils/constant';
import { DateTime } from "luxon";

export default {
  name: "ActionMgt",
  components: {
    SmartCoupon,
  },
  props: {
    strategyAction: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      reminderTimeOpt: [],
      formLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 8
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 20 : 16
      },

      actionCreateVisible: false,
      ationTypeRules: {
        actionType: [
          { required: true, message: () => this.$t('message.pushStrategy.pleaseSelectAction'), trigger: "change" },
        ],
        intelligence: [
          {
            required: true,
            message: () => this.$t('message.pushStrategy.pleaseSelectIntelligentOrNot'),
            trigger: "change"
          },
        ],
      },
      actionTypeList: [

        { title: "SMS", value: 1 },

        { title: 'Email', value: 2 }

      ],
      actionTypeObj: {
        actionType: null,
        intelligence: 0,
        supplier: '',
        email: ''
      },
      strategyActionObj: {},
      appModel: "2", // 自定义文案
      textValue: undefined,
      push_txts: [],
      loading_sms: false,
      disabledSubmitBtn: false,
      showTimeZoneWarning: false,
    };
  },

  mounted() {
    utils.languageChange(this, { labelCol: 6, wrapperCol: 17 }, { labelCol: 4, wrapperCol: 19 })
    this.initReminderTimeOpt()
  },
  watch: {
    strategyAction: {
      handler(v) {
        if (v.strategy_id && this.actionVisible) {
          this.getStrategyAction()
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    handleTimeZoneChange() {
      if (!this.strategyActionObj.time_zone || !this.strategyActionObj.expiry_start_date ||
        this.strategyActionObj.strategy_type == 'Cycle') {
        return;
      }

      try {
        // 获取用户当前系统时间
        const currentDate = DateTime.local({ zone: this.strategyActionObj.time_zone });
        // 获取策略开始日期
        let expiryStartISO = this.strategyActionObj.expiry_start_date;
        // 如果日期格式中不包含 'T'，则添加当前时间信息
        if (!expiryStartISO.includes('T')) {
          // 修正：使用正确的日期变量和格式
          expiryStartISO = this.strategyActionObj.expiry_start_date + `T${this.strategyActionObj.push_time}:00`;
        }
        console.log(expiryStartISO)
        const selectedDate = DateTime.fromISO(expiryStartISO, { zone: this.strategyActionObj.time_zone });
        console.log("🚀 ~ handleTimeZoneChange ~ selectedDate:", selectedDate)
        console.log("🚀 ~ handleTimeZoneChange ~ currentDate:", currentDate)

        // 将时分秒设置到 selectedDate 中
        this.showTimeZoneWarning = selectedDate < currentDate;
        this.disabledSubmitBtn = selectedDate < currentDate;
      } catch (error) {
        console.error('处理时间时区时出错:', error);
      }
    },
    initReminderTimeOpt() {
      const options = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          const h = hour.toString().padStart(2, '0');
          const m = minute.toString().padStart(2, '0');
          const time = `${h}:${m}`;
          options.push({
            label: time,
            value: time
          });
        }
      }
      this.reminderTimeOpt = options;
    },
    showModal() {
      this.actionTypeObj = {
        actionType: null,
        intelligence: 0,
        supplier: '',
        email: ''
      }
      this.appModel = "2";
      this.textValue = undefined;
      this.showTimeZoneWarning = false
      this.disabledSubmitBtn = false
      this.strategyActionObj.push_time = '00:00'

      this.$nextTick(() => {
        this.actionCreateVisible = true;
      })
    },

    getStrategyAction() {
      const params = { strategy_id: this.strategyAction.strategy_id };
      launchStrategyService
        .getStrategyAction(this, { params })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.actionTagList = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log("查询失败！" + error);
        });
    },
    actionCreateVisibleCancel() {

      this.actionCreateVisible = false;
      this.$emit("refreshStrategyTable");

    },
    queryAll() {
      this.formLoading = true;
      this.push_txts = [];
      let name = { channel: contentChannel.getLabelByValue(this.actionTypeObj.actionType).toLocaleLowerCase(), is_auto: this.strategyActionObj.is_auto };
      contentListService
        .getAllContentList(this, { params: name })
        .then(
          function (response) {
            var res = response.data;
            if (res.code == "200") {
              console.log(res.data)
              this.push_txts = res.data;
              console.log(this.push_txts)
            } else {
              this.$message.error(res.message);
            }
          }.bind(this)
        )
        .catch((reponse) => {
          console.log(reponse);
        }).finally(() => {
          this.formLoading = false;
        });;
    },
    actionCreateNext(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          const actionType = this.actionTypeObj.actionType;
          const intelligence = this.actionTypeObj.intelligence; // 0(否) 1(是)
          this.strategyActionObj = this.strategyAction//utils.deepCopy(this.strategyAction);
          this.strategyActionObj.is_auto = intelligence;
          switch (actionType) {
            case 1:

              this.queryAll()
              this.strategyActionObj.action_name = 'SMS';
              this.textValue = [];
              break;
            case 2:
              this.queryAll();
              this.strategyActionObj.action_name = 'Email';
              this.textValue = [];
              break;

          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeActionType(val) {
      this.actionTypeObj.intelligence = 0
      this.actionCreateNext('ationTypeRef')
    },
    txtFilterOption(input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    },
    tabChangeXun(val) {//多选 但是传给后端只取第一个 新增
      if (val.length > 0) {
        let tab_value = val[0]
        this.strategyActionObj.detail_id = tab_value.key

        let label = tab_value.label
        let index = label.indexOf('(')
        this.strategyActionObj.detail_name = label.slice(0, index)


      }
    },
    saveActionHandle(type) {
      if(!this.strategyActionObj.push_time){
        this.showTimeZoneWarning = true
        return
      }

      let data = this.strategyActionObj

      data.detail_id = this.textValue.key
      data.detail_name = this.textValue.label

      if (type === 'sms') {
        data.action_type = 1;

        data.action_name = 'SMS';

      }

      if (type === "email") {

        data.action_type = 2;
        data.action_name = 'Email';
      }

      this.saveStrategyAction(data, type);
    },
    saveStrategyAction(data, type) {
      this.loading_sms = true
      delete data.is_auto
      launchStrategyService
        .saveStrategyAction(this, { data: data })
        .then((response) => {
          let res = response.data;
          if (res.code == 200 || res.code == 201) {
            
            this.$message.success(res.message);
            console.log(type)
            this.$store.dispatch('fetchButtonPermission')
            this.actionCreateVisibleCancel()
            // 数据显示到行为管理弹窗 处理
            this.getStrategyAction()
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        })
        .finally(() => {
          this.loading_sms = false
        })
    },
  }
}
</script>
<style scoped>
.event-type-tab>>>.ant-radio-button-wrapper {
  border: 1px solid #d8d8d8;
}

.event-type-tab>>>.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #000000;
  background: #e7e7e7;
  border: 1px solid #e7e7e7;
}

.event-type-tab>>>.ant-radio-button-wrapper-disabled {
  background: #fff;
}

.event-type-text {
  width: 204px;
  text-align: center;
}

.font-style {
  padding-right: 10px;
  color: #000000;
}

.tag-container {
  height: 130px;
  width: 100%;
}

.tag-item {
  display: inline-block;
  font-size: 16px;
  color: #000000;
  padding: 10px 20px;
  background: #f0f0f0;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 4px 4px 4px 4px;
  margin-right: 20px;
  margin-bottom: 30px;
}

.tag-item:hover {
  cursor: pointer;
  background-color: var(--main-color);
  color: var(--font-color);
  position: relative;
}

.tag-item[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  left: 0;
  top: -40px;
  z-index: 20;
  white-space: nowrap;
  color: #000000;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.tag-empty {
  width: 100%;
  height: 130px;
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
}

.action-container>>>.ant-modal-body {
  padding-left: 24px !important;
}
</style>
